/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { wordTimingSchema } from '../shared/word-timing-schema';

export const getExampleAudioV2ResultSchema = z.object({
  audioUrl: z.string(),
  wordTimings: z.array(wordTimingSchema).optional(),
});

export type IGetExampleAudioV2Result = z.infer<typeof getExampleAudioV2ResultSchema>;

export const getExampleAudioV2ResponseSchema = createApiResponseSchema(
  getExampleAudioV2ResultSchema,
) as z.ZodSchema<IAPI<IGetExampleAudioV2Result>>;

export type IGetExampleAudioV2Response = IAPI<IGetExampleAudioV2Result>;
